import React, { useState } from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './SSOLogin.css';
import { activateUser } from '../services/backendService';
import { testDeactivation } from '../services/schedulerService';

const SSOLogin = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [testResult, setTestResult] = useState(null);
  const [isTesting, setIsTesting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const result = await activateUser(email);
      console.log('Activation result:', result);
      setSuccess(true);
      setEmail('');
      setTimeout(() => {
        window.location.href = 'https://login.alchemer.com/?alias=eab';
      }, 1500);
    } catch (err) {
      console.error('Form submission error:', err);
      let errorMessage = '';
      
      if (err.response) {
        errorMessage = err.response.data.error;
      } else if (err.request) {
        // Request was made but no response received
        errorMessage += 'No response from server. Please check your internet connection.';
      } else {
        // Something else went wrong
        errorMessage += err.message || 'An unexpected error occurred.';
      }
      
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  const handleTestDeactivation = async () => {
    setIsTesting(true);
    setError(null);
    setTestResult(null);
    
    try {
      console.log('Starting test deactivation...');
      const result = await testDeactivation();
      console.log('Test result:', result);
      setTestResult(result);
    } catch (err) {
      console.error('Test error:', err);
      setError(`Test failed: ${err.message}`);
    } finally {
      setIsTesting(false);
    }
  };

  return (
    <div className="sso-login-container">
      <div className="login-card">
        <div className="header-section">
          <div className="logo-container">
            <img 
              className="logo" 
              src="/eab-logo.png"
              alt="EAB Logo"
            />
          </div>
          <h1>Alchemer SSO</h1>
          <p>Log in with your EAB SSO email — the full address you use for EAB applications (including @eab.com).</p>
        </div>

        {/* Persistent green notice banner */}
        <div className="restored-notice">
          <div className="restored-notice-content">
            <i className="fas fa-check-circle"></i>
            <p>
              Alchemer access has been restored. If you have any issues please
              contact{' '}
              <a href="mailto:techsupport@eab.com">techsupport@eab.com</a> with
              a screenshot to assist in troubleshooting.
            </p>
          </div>
        </div>
        
        <div className="login-form-section">
          <form onSubmit={handleSubmit} className="mb-6">
            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@eab.com"
                required
              />
            </div>
            <button type="submit" disabled={isLoading}>
              {isLoading ? (
                <>
                  <i className="fas fa-spinner fa-spin"></i>
                  <span>Authenticating...</span>
                </>
              ) : (
                <>
                  <span>Continue to Alchemer</span>
                  <i className="fas fa-arrow-right"></i>
                </>
              )}
            </button>
          </form>
          
          {error && (
            <div className="error-message">
              <div className="error-content">
                <i className="fas fa-circle-exclamation"></i>
                <p>{error}</p>
              </div>
            </div>
          )}

          {success && (
            <div className="success-message">
              <div className="success-content">
                <i className="fas fa-check-circle"></i>
                <p>Account activated successfully! Redirecting to Alchemer...</p>
              </div>
            </div>
          )}

        </div>

        <p className="support-notice">
          If you need assistance, please contact{' '}
          <a href="mailto:techsupport@eab.com?subject=Alchemer%20Access%20Issue">Tech Support</a>.
        </p>

        
        <div className="footer-section">
          <p>© {new Date().getFullYear()} All rights reserved</p>
        </div>
      </div>
    </div>
  );
};

export default SSOLogin; 